import { PaginatorLaboratoryDynamicDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-dynamic-datasource'
import archiveFilterService from '@/modules/archiveModule/services/archiveFilterService'
import { Nullable } from '@/shared/types/app.types'
import { CommonFilterModel, CommonSortModelResource } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

export class ArchiveDatasource<T> extends PaginatorLaboratoryDynamicDatasource<T> {
    private readonly _params: Nullable<any>

    constructor(laboratoryId: number, url: string, params?: any) {
        super(archiveFilterService, laboratoryId, url)
        this._params = params
    }

    paginator(
        filterModel: CommonFilterModel,
        sortModel: CommonSortModelResource[],
        page: number = 0,
        size: number = 20
    ): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }

        const params = {
            ...this._params,
            sort: GridUtils.getSortValue(sortModel),
            page,
            size
        }
        return this.service.paginator(filterModel, params, this.laboratoryId, this._url)
    }
}
